import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/19.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonKomandirov = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Командиров Евгений Витальевич</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Automation and Control, Master of Technical Sciences
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={"https://orcid.org/0000-0002-3549-8393"}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Атриум Строй Инвест», инженер АСУ и ТК</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Инженер-проектировщик</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Составление схем, чертежей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Организация передачи данных от АСМВР до АРМ оператора, архивация, визуализация.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    М.т.н. по «Автоматизации и управлению». Навыки: MatLab+Simulink, AutoCAD. Знание автоматизации, электротехники, математического моделирования, проектирования АСМ и ЧМИ.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR21882258 «Экологический мониторинг эмиссий» (2023-2025) — исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026) — исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Neftissov et al. Selection of optimal water resources measurement method in Zhambyl province.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Kirichenko et al. Methods for determining emissions from stationary sources. Вестник Торайгыров ун-та, №3, 2024.
                </MyText>
            </Flex>
        </Flex>
    );
};
